<template>
  <!--
      作者：zhuchangtao
      时间：2021-02-03
      描述：批量发货
  -->
  <el-dialog title="批量导入题目" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
      <el-tabs>
      <el-upload
        class="upload-demo"
        ref="upload"
        action="/index.php/shop/topic.delivery/csv"
        accept=".xlsx,.xls"
        :limit="1"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :on-success="uploadFileSuccess"
        :auto-upload="false"
        drag

       >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将题目文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传xls/xlsx文件</div>
      </el-upload>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible">取 消</el-button>
        <el-button type="primary" @click="submitUpload" :loading="loading">确 定</el-button>
      </div>
  </el-dialog>
</template>

<script>

  export default {
    data() {
      return {
        loading: false,
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,

      };
    },
    props: ['open_add', 'form'],
    created() {
      this.dialogVisible = this.open_add;
    },
    methods: {
      /*批量发货*/
      submitUpload() {
        this.$refs.upload.submit();

      },
      //上传成功后台回调
      uploadFileSuccess(response, file, fileList){

        if(response.code==0){

          this.$message({
              message: response.msg,
              type: 'success'
          });
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        }else{
          this.$message(response.msg);//文件上传错误提示
        }
      },
      handleRemove(file, fileList) {
        //console.log(file, fileList);
      },
      handlePreview(file) {
        //console.log(file);
      } ,

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      }

    }
  };
</script>

<style>
  .el-upload{
    display: block!important;
  }
  .el-upload-dragger{
    margin: auto!important;
  }
  .el-upload__tip,.el-upload-list__item-name{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/topic/topic/dialog/FileUpload.vue